module.exports = __webpack_public_path__ + "components/country-flag/static/ma-975eec950376c03f96640fede7cde3e6.svg";